import React from 'react';
import {connect} from 'react-redux';
import BannerList from './BannerList';
import actions from './actions';
import AdminBaseLayoutContainer from "../../components/BaseLayout/AdminBaseLayoutContainer";


const mapStateToProps = state => {
  return {
    ...state.banners,
  };
};

const mapDispatchToProps = actions;

class BannerListContainer extends React.Component {

  componentDidMount() {
    this.props.onInit()
  }

  render() {
    return (
      <AdminBaseLayoutContainer>
        <BannerList {...this.props}/>
      </AdminBaseLayoutContainer>
    )
  }

}


export default connect(mapStateToProps, mapDispatchToProps)(BannerListContainer);
